import url from './url';



export default url(({ testId = ':testId' }) => `/mixins-experiments/${testId}/edit`);
